import { connect } from 'react-redux'
import React, { useState, useEffect } from 'react'
import { t } from 'ttag'

import Field from '../../../form/Field'
import { suggestOccupationsFromInput } from '../../../../actions/search'

const OccupationSuggestField = ({
  searchFilterFormName,
  occupationSuggestions,
  filter,
  form,
  dispatch
}) => {
  const [selected, setSelected] = useState([])

  useEffect(() => {
    if (filter.isApplied) {
      setSelected(filter.value)
    }
  }, [filter.isApplied, filter.value])

  return (
    <Field
      model={`${searchFilterFormName}.${filter.id}`}
      form={form}
      largeTextInput={true}
      theme="bootstrap3"
      label={t`Occupation`}
      type="MultiSelect"
      options={occupationSuggestions}
      onSearchChange={term => dispatch(suggestOccupationsFromInput(term))}
      onChange={selections => {
        setSelected(selections)
      }}
      createFromValue={() => {
        return selected.map(value => {
          return { label: value.name || 'unknown', value }
        })
      }}>
    </Field>
  )
}

export default connect(
  state => {
    const occupationSuggestions = state.search.occupationSuggestionsRequest.result?.map(
      major => {
        return {
          label: major.label,
          value: {
            name: major.label,
            onetSoc: major.value
          }
        }
      }
    )

    //console.log(state.occupations)
    return {
      occupationSuggestions
    }
  },
  dispatch => ({
    dispatch
  })
)(OccupationSuggestField)
